import Main from './MainPage';
import Slogan from './SloganPage';

export const MainPage = Main;
export const SloganPage = Slogan;
